import { Observable, concat, first } from 'rxjs';
import { switchMap, takeUntil, take, mergeMap } from 'rxjs/operators';
import { AnyAction } from 'typescript-fsa';
import { isTypeOfAndGetPayload, IStateObservable } from '@cbridge-utils/redux-observable';
import { path } from '@cbridge-utils/redux';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { ISchedule } from '@cbridge-packages/schedule';
import { ScheduleIntervalAction } from '../scheduleInterval.action';
import { scheduleIntervalStoreSelector } from '../scheduleInterval.selector';

type IState =
  & IGetSelectorStateType<typeof scheduleIntervalStoreSelector>;

interface IAfterAndAlreadyLpDataLoadActions {
  alreadyCheck$: Observable<AnyAction>;
  afterCheck$: Observable<AnyAction>;
}

export const waitForIntervalData = <S extends IState>(
  scheduleId: ISchedule['scheduleId'],
  state$: IStateObservable<S>,
  action$: Observable<AnyAction>,
  afterAndAlreadyInitializeActions: IAfterAndAlreadyLpDataLoadActions,
): Observable<AnyAction> => {
  const { alreadyCheck$, afterCheck$ } = afterAndAlreadyInitializeActions;

  return state$.pipe(
    first(),
    mergeMap((state) => {
      const data = path(scheduleIntervalStoreSelector).data()(state);

      if (data[scheduleId]) {
        return alreadyCheck$;
      }

      return concat(
        [
          ScheduleIntervalAction.load.started({ scheduleId }),
        ],
        action$.pipe(
          isTypeOfAndGetPayload(ScheduleIntervalAction.load.done),
          take(1),
          switchMap(() => {
            return afterCheck$.pipe(
              take(1),
            );
          }),
          takeUntil(
            action$.pipe(
              isTypeOfAndGetPayload(ScheduleIntervalAction.load.failed),
            ),
          ),
        ),
      );
    }),
  );
};
